/* Adeline Wear - variantwissel zonder netwerk (21-09-2026, v2 na Codex-review).

   Waarom: Horizon (assets/variant-picker.js) haalt bij elke kleur- of maatklik de complete
   productpagina op (664 KB decoded), parseert die en laat media-gallery.js de galerij volledig
   vervangen; ook bij een maatklik waar de foto's niet veranderen. Op 4G is dat 3-5 s wachten, en de
   URL-wissel telt in Clarity als een nieuwe pageview.

   Hoe: variant-picker.js roept bovenaan variantChanged() `window.adVariantSwitch.handle(event, picker)`
   aan; is dit de hoofdpicker van het product (niet in een productkaart, quick-add of dialoog, geen
   combined listing), dan werkt deze engine alles bij uit de inline JSON van
   snippets/ad-variant-data.liquid en geeft true terug, waarna Horizon niets meer fetcht. De gewone
   'change'-propagatie blijft intact, dus andere listeners (bv. de sticky-kiezer in ecp-global.js)
   blijven werken. Zit de hook er niet in (bv. na een theme-update), dan valt de engine na 2 s terug
   op een capture-listener op document.

   Bijgewerkt per klik: hidden variant-id + koopknop (label uit block-instelling custom_text via
   data-ad-custom-text), Horizon product-price containers, het eigen ecp-sale-price-blok (instellingen
   via data-ad-*), sticky balk incl. eigen kleur/maat-kiezer, beschikbaarheid/doorstreping per
   optiewaarde (Shopify-semantiek: alleen de VOORAFGAANDE opties tellen mee, gelijk aan
   product_option_value.available bij de eerste render), galerij (spring naar de slide van de
   variantfoto; alle media staan in de DOM sinds hide_variants uit staat), URL (replaceState, zodat
   ATC en deep links kloppen). Geen fetch, geen DOM-vervanging. */
(function () {
  'use strict';

  var dataEl = document.getElementById('ad-variant-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!data || !data.variants || !data.variants.length) return;

  var productId = String(data.product_id);
  var strings = data.strings || {};
  var optionNames = data.options || [];
  var optionCount = optionNames.length;
  var priceFmt = data.currency_code_product_pages ? 'fc' : 'f';
  /* Andere kleuren verbergen (zoals het oude hide_variants, maar dan client-side): slides waarvan het medium
     de variantfoto van een ANDERE variant is krijgen `hidden`. display:none = hun lazy foto laadt niet, dus
     dit maakt de pagina lichter, niet zwaarder. Horizon's slideshow slaat hidden slides zelf al over. */
  var hideOthers = data.hide_other_variant_media !== false;
  var variantMediaIds = {};
  var byId = {};
  data.variants.forEach(function (v) { byId[String(v.id)] = v; if (v.media_id) variantMediaIds[String(v.media_id)] = 1; });
  var initial = byId[String(data.current_variant_id)] || data.variants[0];
  var lastMediaId = initial && initial.media_id ? String(initial.media_id) : null;

  var STRIKE_SVG =
    '<svg viewBox="0 0 100 46" preserveAspectRatio="xMidYMid slice" class="variant-option__strikethrough" aria-hidden="true">' +
    '<line x1="100" y1="0" x2="0" y2="46" vector-effect="non-scaling-stroke"></line>' +
    '<line x1="100" y1="0" x2="0" y2="46" vector-effect="non-scaling-stroke"></line></svg>';
  var PILL_HTML = '<span class="variant-option__button-label__pill" data-key="variant-option-pill"></span>';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inOverlay(el) { return !!(el.closest && el.closest('product-card, quick-add-dialog, dialog')); }

  /* De hoofdpicker van dit product: niet die in een productkaart, quick-add of dialoog. */
  function isMainPicker(p) {
    return !!p && p.tagName === 'VARIANT-PICKER' && p.dataset.templateProductMatch === 'true' &&
      String(p.dataset.productId) === productId && !inOverlay(p);
  }
  function mainPicker() {
    var all = $$('variant-picker[data-template-product-match="true"]');
    for (var i = 0; i < all.length; i++) if (isMainPicker(all[i])) return all[i];
    return null;
  }
  function sectionOf(picker) { return picker.closest('.shopify-section') || document; }

  function optionIndexByName(name) {
    if (!name) return -1;
    var n = String(name).toLowerCase();
    for (var i = 0; i < optionCount; i++) if (String(optionNames[i]).toLowerCase() === n) return i;
    return -1;
  }

  function uniqueValues(i) {
    var seen = {}, out = [];
    data.variants.forEach(function (v) { var o = v.options[i]; if (!(o in seen)) { seen[o] = 1; out.push(o); } });
    return out;
  }

  /* Gekozen waarde per optie-index. Opties met maar een waarde hebben geen fieldset in Horizon;
     die halen we uit de variantlijst. */
  function selectedValues(picker) {
    var values = [];
    for (var i = 0; i < optionCount; i++) values[i] = null;
    $$('fieldset[data-fieldset-index]', picker).forEach(function (fs) {
      var i = parseInt(fs.dataset.fieldsetIndex, 10);
      if (isNaN(i)) return;
      var c = fs.querySelector('input:checked');
      values[i] = c ? c.value : null;
    });
    $$('select.variant-option__select', picker).forEach(function (s) {
      var m = /-(\d+)$/.exec(s.id || '');
      if (m) values[parseInt(m[1], 10)] = s.value;
    });
    for (var j = 0; j < optionCount; j++) {
      if (values[j] === null) {
        var vals = uniqueValues(j);
        if (vals.length === 1) values[j] = vals[0];
      }
    }
    return values;
  }

  function findVariant(values) {
    for (var k = 0; k < data.variants.length; k++) {
      var v = data.variants[k], ok = true;
      for (var i = 0; i < optionCount; i++) {
        if (values[i] !== null && v.options[i] !== values[i]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Shopify-semantiek van product_option_value.available: een waarde van optie i is leverbaar als er
     een leverbare variant bestaat met die waarde EN de gekozen waarden van de opties VOOR i.
     Latere opties tellen niet mee (zo rendert Liquid het ook bij de eerste keer). */
  function isValueAvailable(i, value, values) {
    for (var k = 0; k < data.variants.length; k++) {
      var v = data.variants[k];
      if (!v.available || v.options[i] !== value) continue;
      var ok = true;
      for (var j = 0; j < i; j++) {
        if (values[j] !== null && v.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  /* ---- koopknop-teksten ---- */
  function atcTextEl(root) {
    var content = $('.add-to-cart-text__content', root);
    if (!content) return null;
    var first = content.querySelector(':scope > span:not([ref])');
    if (!first) return null;
    var inner = first.querySelector(':scope > span');
    return inner || first;
  }
  function setAtcText(root, text) { var el = atcTextEl(root); if (el) el.textContent = text; }

  /* Eigen knoptekst: eerst de block-instelling (data-ad-custom-text uit blocks/add-to-cart.liquid),
     anders de starttekst van de knop zolang de startvariant leverbaar is. */
  function rememberAtcLabel(root) {
    if (!root || root.dataset.adLabel) return;
    var wrap = root.closest('[data-ad-custom-text]');
    if (wrap && wrap.dataset.adCustomText) { root.dataset.adLabel = wrap.dataset.adCustomText; return; }
    var btn = root.matches('button') ? root : $('[ref="addToCartButton"]', root);
    var el = atcTextEl(root);
    if (btn && el && !btn.disabled && initial && initial.available) root.dataset.adLabel = el.textContent.trim();
  }
  function atcLabel(variant, root) {
    if (!variant) return strings.unavailable || 'Unavailable';
    if (!variant.available) return strings.sold_out || 'Sold out';
    return (root && root.dataset.adLabel) || strings.add_to_cart || 'Add to cart';
  }

  /* ---- 1. beschikbaarheid + doorstreping per optiewaarde ---- */
  function markAvailability(picker, values) {
    $$('fieldset[data-fieldset-index]', picker).forEach(function (fs) {
      var i = parseInt(fs.dataset.fieldsetIndex, 10);
      if (isNaN(i)) return;
      $$('input[type="radio"]', fs).forEach(function (input) {
        var avail = isValueAvailable(i, input.value, values);
        input.dataset.optionAvailable = avail ? 'true' : 'false';
        if (avail) input.removeAttribute('aria-disabled'); else input.setAttribute('aria-disabled', 'true');
        input.setAttribute('aria-label', input.value + (avail ? '' : ' - ' + (strings.sold_out || 'Sold out')));
        var label = input.closest('label') || input.parentElement;
        if (!label) return;
        var strike = label.querySelector('.variant-option__strikethrough');
        if (!avail && !strike) label.insertAdjacentHTML('beforeend', STRIKE_SVG);
        if (avail && strike) strike.remove();
        var text = label.querySelector('[data-key="variant-option-text"]');
        if (text) {
          var pill = label.querySelector('[data-key="variant-option-pill"]');
          if (avail && !pill) text.insertAdjacentHTML('beforebegin', PILL_HTML);
          if (!avail && pill) pill.remove();
        }
      });
    });
    /* dropdown-stijl: Horizon toont "Waarde - Unavailable" in de optietekst */
    $$('select.variant-option__select', picker).forEach(function (s) {
      var m = /-(\d+)$/.exec(s.id || '');
      if (!m) return;
      var i = parseInt(m[1], 10);
      $$('option', s).forEach(function (o) {
        var avail = isValueAvailable(i, o.value, values);
        o.textContent = avail ? o.value : o.value + ' - ' + (strings.unavailable || 'Unavailable');
      });
    });
    try { if (typeof picker.updateVariantPickerCss === 'function') picker.updateVariantPickerCss(); } catch (e) { /* cosmetisch */ }
  }

  /* ---- 2. koopformulier (alleen in de sectie van de hoofdpicker, niet in kaarten/quick-add) ---- */
  function updateForms(section, variant) {
    var available = !!(variant && variant.available);
    $$('product-form-component', section).forEach(function (form) {
      if (String(form.dataset.productId) !== productId || inOverlay(form)) return;
      var idInput = $('input[ref="variantId"]', form) || $('input[name="id"]', form);
      if (idInput) idInput.value = variant ? String(variant.id) : '';
      var container = $('add-to-cart-component', form);
      if (container) {
        var button = $('[ref="addToCartButton"]', container);
        try {
          if (available && typeof container.enable === 'function') container.enable();
          else if (!available && typeof container.disable === 'function') container.disable();
          else if (button) button.disabled = !available;
        } catch (e) { if (button) button.disabled = !available; }
        if (variant && variant.image_100) container.setAttribute('data-product-variant-media', variant.image_100);
        rememberAtcLabel(container);
        setAtcText(container, atcLabel(variant, container));
        var icon = $('.add-to-cart-icon', container);
        if (icon) icon.hidden = !available;
        var priceEl = $('.add-to-cart-price', container);
        if (priceEl && variant) priceEl.textContent = variant.price_f;
      }
      var accel = $('[ref="acceleratedCheckoutButtonContainer"]', form);
      if (accel) { if (available) accel.removeAttribute('hidden'); else accel.setAttribute('hidden', 'true'); }
    });
  }

  /* ---- 3. prijzen ---- */
  function updatePriceContainer(root, variant) {
    if (!root || !variant) return;
    var onSale = variant.compare_at_price > variant.price;
    var regular = $('.price__regular', root);
    var sale = $('.price__sale', root);
    if (regular) {
      regular.classList.toggle('price__hidden', onSale);
      var p = $('.price', regular);
      if (p) p.textContent = variant['price_' + priceFmt];
    }
    if (sale) {
      sale.classList.toggle('price__hidden', !onSale);
      var s = $('.price-item--sale', sale);
      if (s) s.textContent = variant['price_' + priceFmt];
      var c = $('.compare-at-price', sale);
      if (c) c.textContent = variant['compare_' + priceFmt];
    }
  }

  /* Eigen sale-prijsblok (blocks/ecp-sale-price.liquid). Instellingen komen als data-ad-* mee;
     ontbreken die (oudere render), dan lezen we ze af van de start-DOM. */
  function ecpSettings(el) {
    var d = el.dataset;
    if (!d.adInit) {
      d.adInit = '1';
      if (d.adCurrency === undefined) {
        var cur = $('.ecp-sale-price__current', el);
        var txt = cur ? cur.textContent.trim() : '';
        d.adCurrency = (initial.price_fc !== initial.price_f && txt === initial.price_fc) ? 'true' : 'false';
      }
      if (d.adSave === undefined) {
        var save = $('.ecp-sale-price__save', el);
        d.adSave = save ? 'true' : 'false';
        if (save && !d.adSaveText) d.adSaveText = save.textContent.replace(/\s*\d+\s*%\s*$/, '').trim() || 'Save';
      }
    }
    return { fmt: d.adCurrency === 'true' ? 'fc' : 'f', save: d.adSave === 'true', saveText: d.adSaveText || 'Save' };
  }

  function updateEcpSalePrice(section, variant) {
    $$('.ecp-sale-price', section).forEach(function (el) {
      if (inOverlay(el)) return;
      var st = ecpSettings(el);
      var onSale = variant.compare_at_price > variant.price;
      var cur = $('.ecp-sale-price__current', el);
      var cmp = $('.ecp-sale-price__compare', el);
      var save = $('.ecp-sale-price__save', el);
      if (cur) cur.textContent = variant['price_' + st.fmt];
      if (onSale) {
        if (!cmp) { cmp = document.createElement('span'); cmp.className = 'ecp-sale-price__compare'; el.insertBefore(cmp, cur || el.firstChild); }
        cmp.textContent = variant['compare_' + st.fmt];
      } else if (cmp) { cmp.remove(); }
      if (onSale && st.save) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        if (!save) { save = document.createElement('span'); save.className = 'ecp-sale-price__save'; el.appendChild(save); }
        save.textContent = st.saveText + ' ' + pct + '%';
      } else if (save) { save.remove(); }
    });
  }

  function updatePrices(section, variant) {
    $$('product-price', section).forEach(function (pp) {
      if (pp.dataset.productId && String(pp.dataset.productId) !== productId) return;
      if (inOverlay(pp)) return;
      updatePriceContainer($('[ref="priceContainer"]', pp) || pp, variant);
    });
    updateEcpSalePrice(section, variant);
  }

  /* ---- 4. sticky balk (Horizon-balk + eigen kleur/maat-kiezer erin) ---- */
  function updateSticky(section, variant, values) {
    var available = !!(variant && variant.available);
    $$('sticky-add-to-cart', section).forEach(function (st) {
      if (String(st.dataset.productId) !== productId) return;
      st.dataset.currentVariantId = variant ? String(variant.id) : '';
      st.dataset.variantAvailable = available ? 'true' : 'false';
      var title = $('.sticky-add-to-cart__variant', st);
      if (title) title.textContent = variant ? variant.title : values.filter(Boolean).join(' / ');
      var img = $('[ref="productImage"]', st);
      if (img && variant && variant.image_120) { img.removeAttribute('srcset'); img.src = variant.image_120; }
      if (variant) updatePriceContainer($('[ref="priceContainer"]', st), variant);
      var btn = $('[ref="addToCartButton"]', st);
      if (btn) { rememberAtcLabel(btn); btn.disabled = !available; setAtcText(btn, atcLabel(variant, btn)); }
      $$('.sticky-atc-swatch, .sticky-atc-size', st).forEach(function (b) {
        var i = optionIndexByName(b.getAttribute('data-option'));
        if (i > -1) b.classList.toggle('is-selected', values[i] === b.getAttribute('data-value'));
      });
      $$('.sticky-atc-select', st).forEach(function (s) {
        var i = optionIndexByName(s.getAttribute('data-option'));
        if (i > -1 && values[i] !== null && s.value !== values[i]) s.value = values[i];
      });
    });
  }

  /* ---- 5. galerij: spring naar de slide van de variantfoto ---- */
  function slidesOf(slideshow) {
    var refs = slideshow.refs && slideshow.refs.slides;
    if (refs && refs.length) return Array.prototype.slice.call(refs);
    return $$(':scope > slideshow-container > slideshow-slides > slideshow-slide', slideshow);
  }
  function slideForMedia(section, mediaId) {
    if (!mediaId) return null;
    var gallery = $('media-gallery', section);
    var slideshow = gallery && $('slideshow-component', gallery);
    if (!slideshow) return null;
    var slides = slidesOf(slideshow);
    for (var i = 0; i < slides.length; i++) {
      var m = slides[i].querySelector('.product-media[data-media-id]');
      if (m && String(m.dataset.mediaId) === String(mediaId)) return { slideshow: slideshow, slide: slides[i], index: i };
    }
    return null;
  }
  /* Laadt de foto van een (verborgen) slide via het echte <img>: zelfde srcset/sizes als straks zichtbaar,
     dus bij de klik is er niets meer te halen. priority = 'high' (klik/aanraking) of 'low' (achtergrond). */
  /* Foto's op volgorde (22-09-2026): slides 2+ zijn "ad-gated" (perf-lazy-img.liquid): hun src/srcset staan in
     data-src/data-srcset en src is een lege placeholder-svg, tot dit script (of de 0px-loader in theme.liquid als de
     slide echt in beeld is) ze vrijgeeft. isLoaded() telt de placeholder dus niet als geladen. */
  function isGated(img) { return !!(img && (img.hasAttribute('data-src') || img.hasAttribute('data-srcset'))); }
  function isLoaded(img) { return !!(img && !isGated(img) && img.complete && img.naturalWidth > 0 && !/^data:/.test(img.currentSrc || '')); }
  function revealImg(img) {
    if (!img || !isGated(img)) return;
    var ss = img.getAttribute('data-srcset'), sr = img.getAttribute('data-src');
    if (ss !== null) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
    if (sr !== null) { img.setAttribute('src', sr); img.removeAttribute('data-src'); }
    img.classList.remove('ad-gated'); img.classList.remove('perf-lazy');
  }
  function eagerLoad(slide, priority) {
    var img = slide && slide.querySelector('img');
    if (!img) return null;
    revealImg(img);
    if (priority) { try { img.setAttribute('fetchpriority', priority); } catch (e) { /* hint */ } }
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    return img;
  }
  function gallerySlideshow(section) {
    var gallery = $('media-gallery', section);
    return gallery && $('slideshow-component', gallery);
  }
  function visibleSlides(slideshow) {
    var v = null;
    try { v = slideshow.slides; } catch (e) { v = null; }
    if (v && v.length) return Array.prototype.slice.call(v);
    return slidesOf(slideshow).filter(function (s) { return !s.hasAttribute('hidden'); });
  }
  /* Verberg de variantfoto's van andere varianten; toon die van de gekozen. Geeft true terug als er iets veranderde. */
  function applyMediaVisibility(section, variant) {
    if (!hideOthers) return false;
    var slideshow = gallerySlideshow(section);
    if (!slideshow) return false;
    var keep = variant && variant.media_id ? String(variant.media_id) : null;
    var changed = false;
    slidesOf(slideshow).forEach(function (slide) {
      var m = slide.querySelector('.product-media[data-media-id]');
      if (!m) return;
      var id = String(m.dataset.mediaId);
      if (!variantMediaIds[id]) return; // studio/detail-foto's blijven altijd staan
      var hide = id !== keep;
      if (hide && !slide.hasAttribute('hidden')) {
        slide.setAttribute('hidden', ''); slide.setAttribute('aria-hidden', 'true'); slide.removeAttribute('reveal'); changed = true;
      } else if (!hide && slide.hasAttribute('hidden')) {
        slide.removeAttribute('hidden'); changed = true;
      }
    });
    if (changed) {
      var gallery = slideshow.closest('media-gallery');
      try { if (gallery && typeof gallery.__adRemeasure === 'function') gallery.__adRemeasure(); } catch (e) { /* cosmetisch */ }
      updateCounter(slideshow);
    }
    return changed;
  }
  /* Teller "n / totaal" en dots volgen de zichtbare slides. De teller is
     `<span ref="current">1</span><span class="slash">/</span>16`: alleen de laatste tekstnode aanpassen,
     de span met ref="current" moet blijven (Horizon schrijft daarin). Dots zijn per GERENDERDE slide
     (animation-timeline --slide-k), dus de dot van een verborgen slide verbergen en de klik-index van de
     overgebleven dots op de zichtbare index zetten (select() telt in zichtbare slides). */
  function updateCounter(slideshow) {
    var all = slidesOf(slideshow);
    var visible = visibleSlides(slideshow);
    var ctl = slideshow.querySelector('.slideshow-controls__counter');
    if (ctl) {
      var node = null;
      for (var i = ctl.childNodes.length - 1; i >= 0; i--) {
        var n = ctl.childNodes[i];
        if (n.nodeType === 3 && /\d/.test(n.data)) { node = n; break; }
      }
      if (node) node.data = node.data.replace(/\d+/, String(visible.length));
    }
    /* dots (li per gerenderde slide) en thumbnails (button per gerenderde slide): de controls van
       verborgen slides verbergen en de klik-index van de rest op de zichtbare index zetten. */
    [$$('.slideshow-controls__dots > li', slideshow), $$('.slideshow-controls__thumbnail', slideshow)].forEach(function (ctls) {
      if (!ctls.length || ctls.length !== all.length) return;
      var vi = 0;
      all.forEach(function (slide, k) {
        var el = ctls[k];
        var hidden = slide.hasAttribute('hidden');
        el.hidden = hidden;
        var btn = el.matches('button') ? el : el.querySelector('button');
        if (!hidden && btn) { btn.setAttribute('on:click', '/select/' + vi); vi++; }
      });
    });
  }
  var wantedIndex = -1;
  function selectSlide(slideshow, index, attempt) {
    wantedIndex = index;
    try {
      var r = typeof slideshow.select === 'function' ? slideshow.select(index, undefined, { animate: false }) : null;
      if (r && typeof r.then === 'function') r.catch(function () { /* cosmetisch */ });
    } catch (e) { /* de galerij is cosmetisch; de koopflow mag hier nooit op breken */ }
    /* slideshow.select() keert stil terug als er nog een animatie loopt (#disabled); dan nog even proberen */
    setTimeout(function () {
      if (wantedIndex !== index || !slideshow.isConnected) return;
      if (slideshow.current !== index && attempt < 3) selectSlide(slideshow, index, attempt + 1);
    }, 250);
  }
  function updateGallery(section, variant) {
    if (!variant) return;
    applyMediaVisibility(section, variant);
    var hit = slideForMedia(section, variant.media_id);
    if (!hit) return;
    /* De kleurfoto krijgt de lijn alleen (traag 4G: fetchpriority=low op de rest was niet genoeg): de lopende
       achtergrondlading en de directe buren van het doel (die door de sprong in beeld komen, ~900 KB) worden
       geparkeerd tot de kleurfoto binnen is. Elke kleurwissel vernieuwt het hold-token; is het doel al geladen,
       dan wordt een eerdere hold meteen vrijgegeven. Swipet de bezoeker, dan ook. */
    var targetImg = hit.slide.querySelector('img');
    if (targetImg && targetImg.__adParked) unparkOne(targetImg); /* door een eerdere snelle klik geparkeerd */
    if (isBroken(targetImg)) { delete warm.done[String(variant.media_id)]; attempts[String(variant.media_id)] = 0; reloadImage(targetImg); }
    var mySeq = ++holdSeq;
    if (targetImg && !isLoaded(targetImg)) {
      var vis = visibleSlides(hit.slideshow), ti = vis.indexOf(hit.slide);
      vis.forEach(function (s, i) { if (s !== hit.slide && Math.abs(i - ti) <= 2) parkImage(s.querySelector('img')); });
      if (warm.current && warm.current.img !== targetImg) parkImage(warm.current.img);
      warm.hold = true;
      var released = false;
      var release = function () {
        if (released) return; released = true;
        clearTimeout(relTimer);
        targetImg.removeEventListener('load', release); targetImg.removeEventListener('error', release);
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { hit.slideshow.removeEventListener(ev, release, true); });
        if (mySeq !== holdSeq) return; /* een nieuwere klik beheert de parkeerstand nu */
        warm.hold = false; unparkAll(); warmNext();
      };
      var relTimer = setTimeout(release, 5000);
      targetImg.addEventListener('load', release); targetImg.addEventListener('error', release);
      /* echte gebruikersinvoer op de galerij (swipe/scroll) = alles terug; niet op 'scroll', want selectSlide() scrollt zelf */
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { hit.slideshow.addEventListener(ev, release, { capture: true, passive: true }); });
    } else if (warm.hold) {
      warm.hold = false; unparkAll(); warmNext();
    }
    eagerLoad(hit.slide, 'high');
    /* slideshow.select() telt in ZICHTBARE slides, dus de index daarin nemen. */
    var index = visibleSlides(hit.slideshow).indexOf(hit.slide);
    if (index < 0) { hit.slide.removeAttribute('hidden'); index = visibleSlides(hit.slideshow).indexOf(hit.slide); }
    if (index < 0) return;
    selectSlide(hit.slideshow, index, 0);
  }

  /* ---- 6. URL: bewust GEEN wijziging meer bij een variantwissel (22-09-2026) ----
     Elke history.replaceState(?variant=) telde in Microsoft Clarity als een nieuwe pagina: replays knipten na iedere
     kleur-/maatklik met een witte 'laad'-overgang en een sessie van 20 s kreeg 9 'pagina's'. Bewezen artefact (de klant
     ziet niets), maar het maakte de opnames en paginacijfers onbruikbaar. De koopflow leest de variant uit het
     formulier (hidden input name=id), niet uit de URL. Gevolg: verversen of delen van de link opent de standaardkleur
     (of de kleur uit de oorspronkelijke ?variant= van een advertentie of productkaart). */
  function updateUrl(variant) { /* niets */ }

  /* ---- de klik: aangeroepen vanuit variant-picker.js (of via de fallback-listener) ---- */
  function handle(event, picker) {
    var t = event && event.target;
    if (!t || !(t.tagName === 'INPUT' || t.tagName === 'SELECT')) return false;
    picker = picker || (t.closest && t.closest('variant-picker'));
    if (!isMainPicker(picker) || !picker.contains(t)) return false;
    var opt = t.tagName === 'SELECT' ? t.options[t.selectedIndex] : t;
    if (opt && opt.dataset && opt.dataset.connectedProductUrl) return false; // combined listing: Horizon-pad

    try { if (typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(t); } catch (err) { /* cosmetisch */ }
    var fs = t.closest('fieldset');
    var sw = fs && fs.querySelector('.variant-option__swatch-value');
    if (sw) sw.textContent = t.value;

    var values = selectedValues(picker);
    var variant = findVariant(values);
    var section = sectionOf(picker);

    markAvailability(picker, values);
    updateForms(section, variant);
    if (variant) updatePrices(section, variant);
    updateSticky(section, variant, values);
    /* Galerij alleen bewegen als de variantfoto echt verandert (kleur). Een maatklik laat de bezoeker
       staan waar hij was, ook als hij net naar een studiofoto had geswipet. */
    var mediaId = variant && variant.media_id ? String(variant.media_id) : null;
    try {
      if (mediaId && mediaId !== lastMediaId) updateGallery(section, variant);
    } catch (e) { try { warm.hold = false; unparkAll(); } catch (e2) { /* niets */ } }
    if (mediaId) lastMediaId = mediaId;
    updateUrl(variant);
    try { warmNext(); } catch (e) { /* cosmetisch */ }

    try {
      section.dispatchEvent(new CustomEvent('ad:variant:change', {
        bubbles: true,
        detail: { productId: productId, variant: variant, values: values }
      }));
    } catch (err) { /* niets */ }
    return true;
  }

  /* Fallback als variant-picker.js de hook niet (meer) heeft: dan toch afvangen voor Horizon. */
  var fallbackInstalled = false;
  function installFallback() {
    if (fallbackInstalled || window.__adVariantHook) return;
    fallbackInstalled = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      var picker = t && t.closest && t.closest('variant-picker');
      if (!isMainPicker(picker)) return;
      if (handle(e, picker)) e.stopImmediatePropagation();
    }, true);
  }
  setTimeout(installFallback, 2000);

  /* ---- 7. kleurfoto's op de achtergrond voorladen (22-09-2026) ----
     De slides van andere kleuren zijn verborgen (display:none), dus hun lazy foto laadt niet; bij een
     kleurklik wachtte de bezoeker op die download (gemeten: 1,9 s op traag 4G, 0,1 s op wifi). Hier laden
     we ze alvast, via hetzelfde <img> (eagerLoad), zodat de klik daarna nergens meer op wacht.
     Volgorde (22-09, "foto's eerst"): hero (ready pas als die binnen is) → de zichtbare galerij op DOM-volgorde (gekozen
     kleur, slide 2, 3, …) → de kleurfoto's van de andere kleuren, buren van de gekozen kleur eerst; één tegelijk op
     fetchpriority=high (ná de hero mogen de foto's vóór de apps), met wachten op voltooiing. Een aangeraakte,
     aangeklikte of aangeswipete foto gaat via eagerLoad(…, 'high') direct voor. Hele galerij ≈ 1,6 MB op mobiel (832 px):
     bewuste keuze van Nick.
     Data-saver of 2g/3g: niet in bulk (aanraking blijft werken). Zonder connection-API (iOS Safari) gaan we
     door: dat is het grootste deel van de bezoekers. */
  var warm = { started: false, ready: false, busy: false, paused: false, hold: false, done: {}, section: null, current: null };
  /* Parkeren = src/srcset tijdelijk weghalen (browser breekt de download af); terugzetten start hem opnieuw.
     Alleen voor galerij-<img>'s die nog niet compleet zijn. Een geparkeerde achtergrondlading telt als
     onderbroken, niet als klaar, en komt terug in de rij. */
  var parked = [];
  /* Kapotte foto (request mislukt: complete, maar geen pixels): src/srcset opnieuw zetten = echte nieuwe request.
     fetchpriority of loading aanpassen doet dat niet. */
  function isBroken(img) { return !!(img && !isGated(img) && img.complete && img.naturalWidth === 0 && !img.__adParked && (img.getAttribute('src') || img.getAttribute('srcset'))); }
  function reloadImage(img) {
    var ss = img.getAttribute('srcset'), sr = img.getAttribute('src');
    img.removeAttribute('srcset'); img.removeAttribute('src');
    if (ss !== null) img.setAttribute('srcset', ss);
    if (sr !== null) img.setAttribute('src', sr);
  }
  function parkImage(img) {
    if (!img || img.__adParked || isLoaded(img) || isGated(img)) return; /* gated = laadt nog niet, niets te parkeren */
    if (!img.getAttribute('src') && !img.getAttribute('srcset')) return;
    if (warm.current && warm.current.img === img) warm.current.finish(false);
    img.__adParked = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    img.removeAttribute('srcset'); img.removeAttribute('src');
    parked.push(img);
  }
  function unparkOne(img) {
    var a = img && img.__adParked; if (!a) return;
    img.__adParked = null;
    if (img.isConnected) {
      if (a.srcset !== null) img.setAttribute('srcset', a.srcset);
      if (a.src !== null) img.setAttribute('src', a.src);
    }
    var i = parked.indexOf(img); if (i >= 0) parked.splice(i, 1);
  }
  function unparkAll() { while (parked.length) unparkOne(parked[0]); }
  var holdSeq = 0; /* alleen de laatste klik mag de parkeerstand vrijgeven */
  function mediaOrder() {
    var list = [], seen = {};
    data.variants.forEach(function (v) {
      if (v.media_id && !seen[String(v.media_id)]) { seen[String(v.media_id)] = 1; list.push(String(v.media_id)); }
    });
    return list;
  }
  function warmQueue() {
    var q = [];
    /* 1. de zichtbare galerij op volgorde (gekozen kleur, slide 2, 3, …): dat is wat de bezoeker als eerste swipet */
    var slideshow = gallerySlideshow(warm.section);
    if (slideshow) slidesOf(slideshow).forEach(function (slide) {
      if (slide.hasAttribute('hidden')) return;
      var m = slide.querySelector('.product-media[data-media-id]'), img = slide.querySelector('img');
      if (!m || !img || isLoaded(img)) return;
      var id = String(m.dataset.mediaId);
      if (!warm.done[id] && q.indexOf(id) < 0) q.push(id);
    });
    /* 2. daarna de kleurfoto's van de andere kleuren, buren van de gekozen kleur eerst */
    var order = mediaOrder(), cur = lastMediaId, p = order.indexOf(cur);
    order.filter(function (id) { return id !== cur && !warm.done[id] && q.indexOf(id) < 0; }).sort(function (a, b) {
      return Math.abs(order.indexOf(a) - p) - Math.abs(order.indexOf(b) - p);
    }).forEach(function (id) { q.push(id); });
    return q;
  }
  /* Swipe/klik in de galerij: wat (bijna) in beeld komt direct laden, buiten de wachtrij om. Niet tijdens een hold
     (dan heeft de aangeklikte kleurfoto de lijn alleen; de swipe zelf geeft de hold al vrij). */
  var revealTimer = 0;
  var userReloads = {};
  function revealVisible() {
    if (warm.hold) return;
    var slideshow = gallerySlideshow(warm.section); if (!slideshow) return;
    var vw = window.innerWidth || 0;
    visibleSlides(slideshow).forEach(function (slide) {
      var r = slide.getBoundingClientRect();
      if (!(r.width && r.right > -r.width && r.left < vw + r.width)) return;
      var img = slide.querySelector('img'); if (!img) return;
      if (isGated(img)) { eagerLoad(slide, 'high'); return; }
      /* Kapotte foto (mislukte request, ook na uitgeputte achtergrondpogingen): een echte gebruikersactie op de galerij
         mag hem opnieuw proberen, maximaal 3× per foto, zodat een blijvende fout geen herlaadlus wordt. */
      if (isBroken(img)) {
        var m = slide.querySelector('.product-media[data-media-id]'); var id = m ? String(m.dataset.mediaId) : null;
        if (id && (userReloads[id] || 0) < 3) { userReloads[id] = (userReloads[id] || 0) + 1; delete warm.done[id]; attempts[id] = 0; reloadImage(img); eagerLoad(slide, 'high'); }
      }
    });
  }
  function scheduleReveal() { clearTimeout(revealTimer); revealTimer = setTimeout(revealVisible, 80); }
  function bulkAllowed() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;
    if (c.saveData) return false;
    var t = String(c.effectiveType || '');
    return !(t === 'slow-2g' || t === '2g' || t === '3g');
  }
  /* done-status: 'loaded' | 'error' | 'missing'; een onderbroken (geparkeerde) of verlopen poging krijgt géén
     status en komt terug in de rij (max 2 pogingen per foto, daarna 'error'). */
  var attempts = {};
  function warmOne(mediaId, cb) {
    var hit = slideForMedia(warm.section, mediaId);
    var img = hit && hit.slide.querySelector('img');
    if (!img) { warm.done[mediaId] = 'missing'; return cb(); }
    if (isLoaded(img)) { warm.done[mediaId] = 'loaded'; return cb(); }
    if (img.__adParked) { return cb(); } /* wacht op unparkAll */
    attempts[mediaId] = (attempts[mediaId] || 0) + 1;
    var finished = false;
    function finish(status) {
      if (finished) return; finished = true;
      clearTimeout(timer); img.removeEventListener('load', ok); img.removeEventListener('error', bad);
      if (warm.current && warm.current.img === img) warm.current = null;
      if (status) warm.done[mediaId] = status;
      else if (attempts[mediaId] >= 2) warm.done[mediaId] = 'error';
      cb();
    }
    function ok() { finish('loaded'); }
    function bad() { finish(attempts[mediaId] >= 2 ? 'error' : null); }
    var timer = setTimeout(function () { finish(null); }, 20000);
    warm.current = { mediaId: mediaId, img: img, finish: finish };
    img.addEventListener('load', ok); img.addEventListener('error', bad);
    if (isBroken(img)) reloadImage(img);
    /* 'high' i.p.v. 'low': de wachtrij start pas ná de hero, en dan gaan de kleurfoto's vóór de apps (Loox, TripleWhale,
       Clarity). Eén tegelijk, dus het blijft één download naast de rest. */
    eagerLoad(hit.slide, 'high');
    if (isLoaded(img)) ok();
  }
  function warmNext() {
    if (!warm.ready || warm.busy || warm.paused || warm.hold || !warm.section || document.hidden) return;
    var q = warmQueue();
    if (!q.length) return;
    warm.busy = true;
    warmOne(q[0], function () { warm.busy = false; setTimeout(warmNext, 50); });
  }
  function startWarm(section) {
    if (warm.started) return;
    warm.started = true; warm.section = section;
    if (!bulkAllowed()) { warm.paused = true; return; }
    var hero = $('media-gallery slideshow-slide:not([hidden]) img', section);
    var go = function () { setTimeout(function () { warm.ready = true; warmNext(); }, 300); };
    if (hero && !isLoaded(hero)) {
      hero.addEventListener('load', go, { once: true }); hero.addEventListener('error', go, { once: true });
    } else go();
    var ss = gallerySlideshow(section);
    if (ss) { ss.addEventListener('scroll', scheduleReveal, { capture: true, passive: true }); ['pointerdown', 'touchstart'].forEach(function (ev) { ss.addEventListener(ev, scheduleReveal, { capture: true, passive: true }); }); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) warmNext(); });
    window.addEventListener('pagehide', function () { warm.paused = true; });
    window.addEventListener('pageshow', function () { if (bulkAllowed()) { warm.paused = false; warmNext(); } });
  }

  /* ---- foto alvast laden zodra iemand een swatch aanraakt (voor de klik is afgerond) ---- */
  function bind() {
    var picker = mainPicker();
    if (!picker) return false;
    var section = sectionOf(picker);
    $$('input[type="radio"][data-variant-id]', picker).forEach(function (input) {
      if (input.__adWarm) return;
      input.__adWarm = true;
      var hit = function () {
        var v = byId[String(input.dataset.variantId)];
        var found = v && slideForMedia(section, v.media_id);
        if (found) eagerLoad(found.slide, 'high');
      };
      var target = input.closest('label') || input;
      target.addEventListener('pointerenter', hit, { passive: true });
      target.addEventListener('touchstart', hit, { passive: true });
      input.addEventListener('focus', hit, { passive: true });
    });
    $$('.ecp-sale-price', section).forEach(ecpSettings);
    $$('product-form-component add-to-cart-component, sticky-add-to-cart [ref="addToCartButton"]', section).forEach(rememberAtcLabel);
    /* bij het laden: alleen de gekozen kleur zichtbaar (de rest blijft in de DOM, maar laadt niet) */
    var cur = byId[String(data.current_variant_id)];
    if (cur) applyMediaVisibility(section, cur);
    startWarm(section);
    return true;
  }
  if (!bind()) setTimeout(bind, 1000);
  document.addEventListener('shopify:section:load', bind);

  window.adVariantSwitch = { version: '2026-09-22.11', data: data, handle: handle, findVariant: findVariant, selectedValues: selectedValues, isValueAvailable: isValueAvailable, warm: warm, warmNext: warmNext };
})();
